require.register("modules/m03/m03-activity/page-9a-co/page-9a-co", function(exports, require, module){
  var BaseExtension = require('base-extension');
var _ = window._ || require('lodash');

var page_9a_co = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {
    view.subscribeEvent('block:values:change', (e) => {
      view.$('form').submit();
    });
  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {
    onComplete();
  }
}, BaseExtension);

module.exports = page_9a_co;


  
});

